module.exports = __webpack_public_path__ + "media/images/pages/hazard/bg_area_07-374779d3847f9b5464e113b66a15a0b4.png";